import { Component, Input, OnInit } from '@angular/core';
import {RewardService} from "../../../../../shared/services/reward.service";

declare var $: any;

@Component({
  selector: 'app-promotion-faq',
  templateUrl: './promotion-faq.component.html',
  styleUrls: ['./promotion-faq.component.scss']
})

export class PromotionFaqComponent implements OnInit {
  @Input() partnerDetails: any;
  partnerDetailContentURL: any;
  frequentlyAskedQuestion;
  showLoading = true;
  isErrorInContent = false;
  @Input() isWebView;
  constructor(private rewardService: RewardService) { }

  ngOnInit(): void {
  if (this.partnerDetails) {
        if (this.partnerDetails.contentPath) {
          this.partnerDetailContentURL = this.partnerDetails.contentPath;
          if(this.isWebView) {
            this.partnerDetailContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'faq');
          } else {
            this.partnerDetailContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.partnerDetailContentURL.replace(/\{partner_section\}/g, 'faq');
          }
          this.getPartnerDetailContentAPI();
        }
      }
    }

    getPartnerDetailContentAPI() {
       this.rewardService.getPromotionDetailContent(this.partnerDetailContentURL).subscribe((promotionDetailData: any) => {
             if (promotionDetailData) {
              this.frequentlyAskedQuestion = this.interpretHtmlContentForNVDA(promotionDetailData);
              this.showLoading = false;
               setTimeout(() => {

                 $('.accordion-header').each(function(){
                    $(this).replaceWith(`<h3 class="${$(this).attr('class')}">${$(this).html()}</h3>`);
                 });

                 // $('.accordion-container-title').remove();
                 $('h3.accordion-header').toggleClass('inactive-header');
                 $('.display-type').each(function () {
                   var displayType = $(this).attr("data-display-type");
                   if (displayType == 'expandFirst') {
                     $(this).find('h3.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
                     $(this).find('.accordion-content').first().slideDown().toggleClass('open-content');
                   } else if (displayType == 'expanded') {
                     $(this).find('h3.accordion-header').toggleClass('active-header').toggleClass('inactive-header');
                     $(this).find('.accordion-content').slideDown().toggleClass('open-content');
                   }
                 });

                 // The Accordion Effect
                 $("h3.accordion-header").each(function () {
                   if ($(this).hasClass('active-header')) {
                     $('.accordion-header').attr('aria-expanded', 'true');
                   } else {
                     $(this).attr('aria-expanded', 'false');
                   }
                 });

                 $('h3.accordion-header').click(function () {
                   if ($(this).is('.inactive-header')) {
                     $(this).toggleClass('active-header').toggleClass('inactive-header');
                     $(this).attr('aria-expanded', 'true');
                     $(this).next().slideToggle().toggleClass('open-content');

                   } else {
                     $(this).toggleClass('active-header').toggleClass('inactive-header');
                     $(this).attr('aria-expanded', 'false');
                     $(this).next().slideToggle().toggleClass('open-content');
                   }
                 });

                 $('h3.accordion-header').keypress(function (e) {
                   var key = e.which;
                   if (key == 13) {
                     if ($(this).is('.inactive-header')) {
                       $(this).toggleClass('active-header').toggleClass('inactive-header');
                       $(this).attr('aria-expanded', 'true');
                       $(this).next().slideToggle().toggleClass('open-content');

                     } else {
                       $(this).toggleClass('active-header').toggleClass('inactive-header');
                       $(this).attr('aria-expanded', 'false');
                       $(this).next().slideToggle().toggleClass('open-content');
                     }
                   }
                 });
               }, 2000);
         }
       }, error => {
            this.showLoading = false;
            this.isErrorInContent = true;
       });
     }

     interpretHtmlContentForNVDA(htmlContent: string): string{

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        const containers = doc.querySelectorAll('div.accordion-content');
        containers.forEach(container => {
            const paragraphs = container.querySelectorAll('p');
            paragraphs.forEach((paragraph, index) => {
                const origText = paragraph.textContent?.trim();

                if(origText){
                    let formattedText = this.convertDatesToWords(origText);
                    formattedText = this.convertPriceToWords(formattedText);
                    paragraph.setAttribute('aria-hidden', 'true');

                    const span = document.createElement('span');
                    span.classList.add('sr-only');
                    span.setAttribute('aria-hidden', 'false');
                    span.setAttribute('role', 'text');
                    span.setAttribute('aria-live','polite');
                    span.setAttribute('id',`sr-text-${index}`);
                    span.textContent = formattedText;

                    paragraph.setAttribute('aria-describedby',`sr-text-${index}`);
                    paragraph.insertAdjacentElement('afterend', span);
                }
            });
        });
        return doc.body.innerHTML;
     }


     convertDatesToWords(text: string): string{
     return text.replace(
        /\b(\d{1,2})\/(\d{1,2})\/(\d{4})\b/g,
            (_match, month, day, year) =>{
                const monthNames = ['January','February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                const dateSuffix = this.getDateSuffix(parseInt(day));
                return `${monthNames[parseInt(month) - 1]} ${parseInt(day)}${dateSuffix}, ${year}`;
            }
        );
     }

     getDateSuffix(day: number): string{
        if (day >= 11 && day <= 13) {
            return 'th';
        }

        switch(day % 10){
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
     }


     convertPriceToWords(text: string): string{
        return text.replace(
            /\$(\d+)\.(\d{2})\/month\b/g,
            (_match, dollars, cents) => {
                return `${dollars} dollars, ${cents} cents per month`;
            }
        );
     }
  }
